<template>
	<ion-loading
		v-if="showReconnecting"
		:is-open="showReconnecting"
		:message="$t('common.reconnecting')"
		spinner="crescent"
	/>
</template>

<script setup lang="ts">
	import { IonLoading } from "@ionic/vue";
	import { useVerifyToken } from "seedgreen-shared/query/verify-token";
	import { computed } from "vue";

	const { tokenValid } = useVerifyToken();

	const showReconnecting = computed(() => tokenValid.value === undefined);
</script>
